import React__default from 'react';
import { __extends, __rest, __assign } from '../../_virtual/_tslib.js';
import classnames from 'classnames';
import { MessageChannel } from '@deal/chat-firebase-client';
import MessageBubble from '../MessageBubble/index.js';
import Linkify from 'linkify-it';
import VideoUrlParser from 'js-video-url-parser';
import ReactPlayer from 'react-player';
import cropUrl from 'crop-url';
import styles from './styles.css.js';

var SUPPORTED_VIDEO_PROVIDERS = ['youtube', 'vimeo']; // SMS messages that automatically cause the sender's phone number to be blacklisted
//   See: https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-

var OPT_OUT_KEYWORDS = new Set(['STOP', 'STOPALL', 'UNSUBSCRIBE', 'CANCEL', 'END', 'QUIT']); // Messaging user types that should see an explanation of how we treat opt-out messages

var CURATED_MESSAGING_USER_TYPES = new Set(['BUSINESS_USER', 'SUPPORT', 'OPERATOR']);

var MessageBubbleText =
/** @class */
function (_super) {
  __extends(MessageBubbleText, _super);

  function MessageBubbleText() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.linkifier = new Linkify();
    return _this;
  }

  MessageBubbleText.prototype.matchLinks = function (text) {
    return this.linkifier.match(text);
  };
  /**
   * Extract the first URL in the text that we can show a rich media preview for.
   *
   * @param text
   */


  MessageBubbleText.prototype.extractRichMedia = function (text) {
    var matches = this.matchLinks(text);

    if (!matches) {
      return undefined;
    }

    return matches.find(function (match) {
      var parsedVideoUrl = VideoUrlParser.parse(match.url);

      if (parsedVideoUrl && SUPPORTED_VIDEO_PROVIDERS.includes(parsedVideoUrl.provider)) {
        return true;
      }

      return false;
    });
  };

  MessageBubbleText.prototype.formatText = function (text) {
    var matches = this.matchLinks(text); // If there are no URLs, skip processing altogether

    if (!matches) {
      return text;
    } // Iterate through the matches, replacing each match with a link while preserving the plain text


    return matches.reduce(function (output, match, index, matches) {
      var previousEndingIndex = index ? matches[index - 1].lastIndex : 0; // Preserve the text preceding this match

      output.push(text.slice(previousEndingIndex, match.index)); // Convert the match to a link

      output.push(React__default.createElement("a", {
        href: match.url,
        title: match.url,
        key: match.url,
        target: "_blank"
      }, cropUrl(match.text, 45))); // If there are no more matches, include the remaining text

      if (index === matches.length - 1) {
        output.push(text.slice(match.lastIndex));
      }

      return output;
    }, []);
  };

  MessageBubbleText.prototype.render = function () {
    var _a;

    var isOptOutMessage = typeof this.props.children === 'string' && OPT_OUT_KEYWORDS.has(this.props.children);
    var showOptOutMessageExplanation = isOptOutMessage && this.props.message.sentVia === MessageChannel.SMS && CURATED_MESSAGING_USER_TYPES.has(this.props.myself.type);

    var _b = this.props,
        children = _b.children,
        message = _b.message,
        myself = _b.myself,
        className = _b.className,
        rest = __rest(_b, ["children", "message", "myself", "className"]);

    var sender = message.sentBy;
    var isTeammate = sender.type === 'BUSINESS_USER' && myself.type === 'BUSINESS_USER' && myself !== sender || sender.type === 'SUPPORT' && myself.type === 'OPERATOR' && myself !== sender;
    var classes = classnames(className, message.sentBy.isMyself ? styles.sent : styles.received, styles.flat, (_a = {}, _a[styles.fromTeammate] = isTeammate, _a)); // If there is a video URL in the text, render a video player

    var richMedia = typeof children === 'string' ? this.extractRichMedia(children) : null; // If the video URL is the only text, don't render the raw text

    var isOnlyRichMediaUrl = typeof children === 'string' && richMedia && richMedia.index === 0 && richMedia.lastIndex === children.length;
    return React__default.createElement(MessageBubble, __assign({
      message: message,
      className: classes,
      fullWidth: !!richMedia
    }, rest), richMedia && React__default.createElement("div", {
      className: styles.richMediaWrapper
    }, React__default.createElement(ReactPlayer, {
      url: richMedia.url,
      className: styles.richMedia,
      width: "100%",
      height: ""
    })), !isOnlyRichMediaUrl && React__default.createElement("div", {
      className: styles.text
    }, typeof children === 'string' ? this.formatText(children) : children, showOptOutMessageExplanation && React__default.createElement("div", {
      className: styles.optOut
    }, React__default.createElement("strong", null, "We removed this phone number from our text message list since the customer responded with \"", this.formatText(children), "\""), React__default.createElement("ul", {
      className: styles.optOutBulletList
    }, React__default.createElement("li", {
      className: styles.optOutBulletItem
    }, "Messages will still be sent to this customer via Curated.com and their email."), React__default.createElement("li", {
      className: styles.optOutBulletItem
    }, "This customer has chosen to not receive text messages, OR it could be that the customer entered the wrong phone number."), React__default.createElement("li", {
      className: styles.optOutBulletItem
    }, "Please continue to help this customer!")))));
  };

  return MessageBubbleText;
}(React__default.Component);

export default MessageBubbleText;
//# sourceMappingURL=index.js.map
